import React, { useEffect } from "react";
import classnames from "classnames";
import "../../../../styles/full-view-popup.scss";
import {
  Customer,
  State,
  useHasPermission,
  AppPermissions,
  Phone,
  EmailAddress,
  useLead,
  Lead,
} from "../../../../core";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import { UserAvatar } from "../../../../components/render-file/UserAvatar";
import CreateCustomer from "../CreateCustomer";
import { toastr } from "react-redux-toastr";
import { useSelector } from "react-redux";
import { SearchCustomer } from "../../../leads/components";
import {
  ValidateEmail,
  ValidateNumber,
  ValidatePhoneNumberRegEx,
} from "../../../../utils/Validatation";
import ExistingClient from "../ExistingClient";

import { StatusCodes } from "http-status-codes";
import MarkInfluence from "../company-customer/MarkInfluence";

interface IAddUserPopupProps {
  onClose: () => void;
  companyId?: string;
  onSucccess: () => void;
}
const ValidStages = ["fetch-customer", "create-customer", "existing-customer"];

export const AddUserPopup: React.FunctionComponent<IAddUserPopupProps> = (
  props
) => {
  const leadState = useSelector((state: State) => state.lead);
  const { updateUsers, updateLeadDetails } = useLead(api.lead);
  const [search, setSearch] = React.useState("");
  const [stage, setStage] = React.useState<string>("fetch-customer");
  const [customerDetails, setCustomerDetails] = React.useState<Customer>();
  const [phones, setPhones] = React.useState<Phone[] | undefined>();
  const [emails, setEmails] = React.useState<EmailAddress[] | undefined>();
  const [searchPhone, setSearchPhone] = React.useState<string>();
  const canCreateCustomer = useHasPermission(AppPermissions.CreateCustomer);

  const [influenceModal, setInfluenceModal] = React.useState<{
    isOpen?: boolean;
    user?: Customer;
  }>({});
  const onAddExistingContactUser = async (data: Customer) => {
    setCustomerDetails(data);

    try {
      const response = await api.customer.addExistingCustomerAsCompanyContact({
        customerId: data._id!,
        companyId: props.companyId!,
      });
      if (response.status === StatusCodes.OK) {
        reload();
        toastr.success("Success", "Contact addded to company successfully");
        setStage("fetch-customer");
        const leadResponse = await api.lead.getLead(
          leadState?.leadDetails?._id!
        );
        updateLeadDetails(leadResponse?.data);
      } else {
        toastr.error(
          "Error",
          response?.message || "Error while adding contact"
        );
      }
    } catch (err) {
      toastr.error(
        "Error",
        "Error while adding contact possibly because the customer is contact of another company"
      );
    }
  };
  const [selectedTab, setSelectedTab] = React.useState("allUsers");

  const [isAddUserOpen, setAddUserOpen] = React.useState(false);

  const [selectedCustomers, setSelectedCustomers] = React.useState<Customer[]>(
    leadState?.leadDetails?.corporateUsers || []
  );

  React.useEffect(() => {
    if (!!leadState?.leadDetails?.corporateUsers?.length) {
      setSelectedCustomers(leadState?.leadDetails?.corporateUsers || []);
    }
  }, [leadState?.leadDetails?.corporateUsers]);

  const { data: customers, reload } = useDataLoader<Customer[]>(() =>
    api.customer.listCompanyContactUsers({
      companyId: props.companyId!,
      page: 1,
      perPage: 50,
      query: search,
    })
  );
  const onSearch = () => {
    reload();
  };

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [canSave, setCanSave] = React.useState<boolean>(false);
  const [designationId, setDesignationId] = React.useState<string|null>(null);


  const onSubmit = async () => {
    const addUsers = selectedCustomers
      ?.filter((x) => x._id)
      ?.map((l) => l._id) as string[];
    const removeUsers = leadState?.leadDetails?.corporateUsers
      ?.filter((x) => !selectedCustomers?.find((s) => s._id === x._id))
      ?.map((l) => l._id) as string[];
    setIsSubmiting(true);
    updateUsers(
      addUsers || [],
      removeUsers || [],
      leadState?.leadDetails?._id,
      async () => {
        setIsSubmiting(false);
        toastr.success("Success", "Users addded to lead successfully");
        const response = await api.lead.getLead(leadState?.leadDetails?._id!);
        updateLeadDetails(response?.data);
      },
      (error) => {
        setIsSubmiting(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
      }
    );
  };

  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      reload();
    }
  };

  const arrayEquals = (a: Customer[], b: Customer[]) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val?._id === b[index]?._id)
    );
  };

  const onFetchDetails = (
    data: Customer,
    query: string,
    searchType?: string
  ) => {
    setDesignationId(null)
    setCustomerDetails(data);
    setPhones(undefined);
    setEmails(undefined);
    setSearchPhone("");
    if (searchType === "mobile" && !data && ValidateNumber(query)) {
      setPhones([
        { phone: query, phoneType: "Mobile", isPrimary: true },
      ]);
    }
    if (searchType === "email" && !data && ValidateEmail(query)) {
      setEmails([{ email: query, emailType: "Business", isPrimary: true }]);
    }

    if (data) {
      setPhones(data?.phones);
      setEmails(data?.emails);
    }
    if (data && ValidatePhoneNumberRegEx(query) && searchType === "mobile") {
      setSearchPhone(query);
    }
    setStage(
      data || !canCreateCustomer ? "existing-customer" : "create-customer"
    );
  };

  const createContactLessCustomer = (val:string) => {
    setDesignationId(val);
    setStage("create-customer");
  };

  useEffect(() => {
    if (search === "") {
      reload();
    }
  }, [search]);

  useEffect(() => {
    if (stage && !ValidStages.find((s) => s === stage)) {
      setStage("fetch-customer"); // default stage
    }
  }, [stage]);

  return (
    <div className="modal-open">
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in add-type-popup">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-99">
          <div className="row align-items-center">
            <div
              className="col-auto"
              onClick={() => {
                props.onClose();
                props.onSucccess();
              }}
            >
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Add Contact</h5>
            </div>
            <div className="col-auto mt-md-0 mt-1">
              <div className="d-inline-flex align-items-center flex-wrap mr-lg-5 mr-sm-3">
                <button
                  onClick={onSubmit}
                  disabled={!canSave || isSubmiting}
                  className="btn btn-primary mr-lg-2 mr-1 px-lg-3 px-2 mb-sm-0 mb-1 font-weight-bold font-normal py-2"
                >
                  Save User
                  {!!selectedCustomers?.length && (
                    <> ( {selectedCustomers?.length})</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-md-5 col-12 border-right">
            <div className="border-bottom d-flex align-items-center">
              <div className="col d-flex">
                <button className="btn p-0 font-base" onClick={onSearch}>
                  <i className="icon-search text-gray-600"></i>
                </button>
                <input
                  type="text"
                  className="form-control border-0 px-2"
                  placeholder={"Search by Name, Mobile"}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </div>
            <ul
              className="nav tab-underline mb-2 border-bottom font-normal font-weight-semibold flex-nowrap text-nowrap overflow-auto px-md-0 px-3 pt-2"
              id="activity-tab"
              role="tablist"
            >
              <li className="nav-item w-50" role="presentation">
                <a
                  className={classnames({
                    "cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 text-center": true,
                    "active text-gray-900": selectedTab === "allUsers",
                  })}
                  onClick={() => {
                    setSelectedTab("allUsers");
                  }}
                >
                  <span className="py-1 d-inline-flex">
                    All User{" "}
                    {!!customers?.length && <> ( {customers?.length})</>}
                  </span>
                </a>
              </li>
              <li className="nav-item w-50" role="presentation">
                <a
                  className={classnames({
                    "cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 text-center": true,
                    "active text-gray-900": selectedTab === "selectedUser",
                  })}
                  onClick={() => {
                    setSelectedTab("selectedUser");
                  }}
                >
                  <span className="py-1 d-inline-flex">
                    Selected User
                    {!!selectedCustomers?.length && (
                      <> ( {selectedCustomers?.length})</>
                    )}
                  </span>
                </a>
              </li>
            </ul>
            {selectedTab === "allUsers" && (
              <ul className="list-unstyled mb-0">
                {customers?.map((user, index) => {
                  return (
                    <li
                      key={index}
                      className={classnames({
                        "border-bottom px-3 py-2 d-flex align-items-center cursor-pointer align-items-sm-start": true,
                        "bg-white": !selectedCustomers?.find(
                          (x) => x._id === user._id
                        ),
                        "bg-gray-100": !!selectedCustomers?.find(
                          (x) => x._id === user._id
                        ),
                      })}
                    >
                      <div className="mr-2">
                        <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                          <svg>
                            <circle
                              r="12"
                              cx="50%"
                              cy="50%"
                              className="default"
                            ></circle>
                            <circle
                              r="12"
                              cx="50%"
                              cy="50%"
                              className="progress"
                              stroke-dasharray="117"
                              stroke-dashoffset="75"
                            ></circle>
                          </svg>
                          <UserAvatar
                            id={user?._id}
                            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                            alt=""
                            title={user?.fullName}
                            imageUrl={user?.photo?.location}
                            image={user?.photo}
                          ></UserAvatar>
                        </div>
                      </div>
                      <div className="py-1">
                        <h6 className="mb-1">{user.fullName}</h6>
                        <p className="mb-0 font-xs text-gray-600 font-weight-semibold">
                          {user.designation?.name}{" "}
                          <div className="bg-gray-400 mx-2 top-0"></div>
                          {user.phones?.find((x) => x.isPrimary)?.phone}
                        </p>
                      </div>
                      <i
                        onClick={() => {
                          const customersSelected = !!selectedCustomers?.length
                            ? [...selectedCustomers]
                            : [];
                          if (
                            !!customersSelected.find((x) => x._id === user._id)
                          ) {
                            setSelectedCustomers(
                              customersSelected?.filter(
                                (x) => x._id !== user._id
                              )
                            );
                            setCanSave(
                              !arrayEquals(
                                leadState?.leadDetails?.corporateUsers!,
                                customersSelected?.filter(
                                  (x) => x._id !== user._id
                                )
                              )
                            );
                          } else {
                            customersSelected.push(user);
                            setSelectedCustomers(customersSelected);
                            setCanSave(
                              !arrayEquals(
                                leadState?.leadDetails?.corporateUsers!,
                                customersSelected
                              )
                            );
                          }
                        }}
                        className={classnames({
                          "icon-add icon-box border align-items-center border cursor-pointer d-flex icon-box justify-content-center ml-auto rounded-sm": true,
                          "icon-add": !selectedCustomers?.find(
                            (x) => x._id === user._id
                          ),
                          "icon-close bg-blue text-white font-sm rounded": !!selectedCustomers?.find(
                            (x) => x._id === user._id
                          ),
                        })}
                      ></i>
                    </li>
                  );
                })}
              </ul>
            )}
            {selectedTab === "selectedUser" && (
              <ul className="list-unstyled mb-0">
                {selectedCustomers?.map((user, index) => {
                  return (
                    <li
                      key={index}
                      className={classnames({
                        "border-bottom px-3 py-2 d-flex align-items-center cursor-pointer align-items-sm-start": true,
                        "bg-white": !selectedCustomers?.find(
                          (x) => x._id === user._id
                        ),
                        "bg-gray-100": !!selectedCustomers?.find(
                          (x) => x._id === user._id
                        ),
                      })}
                    >
                      <div className="mr-2">
                        <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                          <svg>
                            <circle
                              r="12"
                              cx="50%"
                              cy="50%"
                              className="default"
                            ></circle>
                            <circle
                              r="12"
                              cx="50%"
                              cy="50%"
                              className="progress"
                              stroke-dasharray="117"
                              stroke-dashoffset="75"
                            ></circle>
                          </svg>
                          <UserAvatar
                            id={user?._id}
                            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                            alt=""
                            title={user?.fullName}
                            imageUrl={user?.photo?.location}
                            image={user?.photo}
                          ></UserAvatar>
                        </div>
                      </div>
                      <div className="py-1">
                        <h6 className="mb-1">{user.fullName}</h6>
                        <p className="mb-1 font-xs text-gray-600 font-weight-semibold">
                          {user.designation?.name}{" "}
                          <div className="bg-gray-400 mx-2 top-0"></div>
                          {user?.phone ||
                            user.phones?.find((x) => x.isPrimary)?.phone}
                        </p>
                        {(leadState?.leadDetails?.corporateUsers?.length || 0) >
                          0 &&
                          leadState?.leadDetails?.corporateUsers?.find(
                            (u) => u.influencer?._id === user.influencer?._id
                          ) && (
                            <p className="mb-1 font-xs text-gray-600 font-weight-semibold">
                              {user.influencer?.name ? (
                                <>{user.influencer?.name}</>
                              ) : (
                                <span
                                  onClick={() =>
                                    setInfluenceModal({ isOpen: true, user })
                                  }
                                  className="text-primary text-decoration-underline"
                                >
                                  Mark Influence{" "}
                                </span>
                              )}
                            </p>
                          )}
                        {user.influencer?.name &&
                          leadState?.leadDetails?.corporateUsers?.find(
                            (u) => u.influencer?._id === user.influencer?._id
                          ) && (
                            <p className="mb-0 font-xs text-gray-600 font-weight-semibold">
                              <span
                                onClick={() => {
                                  setInfluenceModal({ isOpen: true, user });
                                  setAddUserOpen(false);
                                }}
                                className="text-primary text-decoration-underline"
                              >
                                Edit Influence{" "}
                              </span>
                            </p>
                          )}
                      </div>
                      <i
                        onClick={() => {
                          const customersSelected = !!selectedCustomers?.length
                            ? [...selectedCustomers]
                            : [];
                          if (
                            !!customersSelected.find((x) => x._id === user._id)
                          ) {
                            setSelectedCustomers(
                              customersSelected?.filter(
                                (x) => x._id !== user._id
                              )
                            );
                            setCanSave(
                              !arrayEquals(
                                leadState?.leadDetails?.corporateUsers!,
                                customersSelected?.filter(
                                  (x) => x._id !== user._id
                                )
                              )
                            );
                          } else {
                            customersSelected.push(user);
                            setSelectedCustomers(customersSelected);
                            setCanSave(
                              !arrayEquals(
                                leadState?.leadDetails?.corporateUsers!,
                                customersSelected
                              )
                            );
                          }
                        }}
                        className={classnames({
                          "icon-add icon-box border align-items-center border cursor-pointer d-flex icon-box justify-content-center ml-auto rounded-sm": true,
                          "icon-add": !selectedCustomers?.find(
                            (x) => x._id === user._id
                          ),
                          "icon-close bg-blue text-white font-sm rounded": !!selectedCustomers?.find(
                            (x) => x._id === user._id
                          ),
                        })}
                      ></i>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          <div className="col-md-7 col-12 member-detail bg-white zIndex-1 top-0 left-0 h-100 ">
            {/* {isAddUserOpen && ( */}
            {stage === "fetch-customer" && (
              <div className="" style={{maxWidth : "500px"}}>
                <SearchCustomer
                  onFetchDetails={(
                    details: Customer,
                    query: string,
                    searchType: string
                  ) => onFetchDetails(details, query, searchType)}
                  setStage={(stageName: string) => setStage(stageName)}
                   handleContactlessCustomer={createContactLessCustomer}
                ></SearchCustomer>
              </div>
            )}
            {stage === "existing-customer" && (
              <>
                <ExistingClient
                  customerDetails={customerDetails}
                  setStage={(stageName: string) => setStage(stageName)}
                  phone={searchPhone}
                  onLeadClick={() => undefined}
                  addExistingCustomerAsUser={(details: Customer) =>
                    onAddExistingContactUser(details)
                  }
                  isCompanyLead={true}
                ></ExistingClient>
              </>
            )}
            {stage === "create-customer" && (
              <>
                <CreateCustomer
                  isCompanyCustomer
                  customerDetails={customerDetails}
                  onCreateCustomer={(details: Customer) => {
                    reload();
                    setAddUserOpen(false);
                    setStage("fetch-customer");
                  }}
                  setStage={(stageName: string) => setStage(stageName)}
                  phones={phones}
                  emails={emails}
                  isContact
                  parentCompanyCustomer={leadState.leadDetails?.customer}
                  companyId={props.companyId}
                  gridColumns={2}
                  designationId={designationId}
                  isContactlessCustomer={!!designationId}
                ></CreateCustomer>
              </>
            )}
            {influenceModal?.isOpen && (
              <MarkInfluence
                user={influenceModal.user}
                onSuccess={(lead: Lead) => {
                  reload();
                  setInfluenceModal({});
                  updateLeadDetails(lead);
                }}
                onClose={() => {
                  setInfluenceModal({});
                }}
                leadId={leadState?.leadDetails?._id}
              ></MarkInfluence>
            )}
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </div>
  );
};
